module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.48-199.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.0-rc.48.md
// module id = 642
// module chunks = 369